import { FormGroup, FormSection } from '@ksyos/design-system';
import type { IService } from '@common/interfaces/';
import { getAnalystAllowedByServiceCode } from '@common/utils/getAnalystAllowedByServiceCode';
import { translateKey } from '@frontend/translate';
import { OrganizationSelection } from '../../../../elements/OrganizationSelection';

export interface IKsyosHolterAnalystOrganizationProps {
    error?: string;
    ksyosHolterAnalystOrganizationId?: string;
    onChange: (ksyosHolterAnalystOrganizationId?: string) => void;
    onDoValidate?: () => void;
    service: IService;
}

export function KsyosHolterAnalystOrganization(props: IKsyosHolterAnalystOrganizationProps) {
    if (!getAnalystAllowedByServiceCode(props.service.code)) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.ksyosHolterAnalystOrganization')}>
            <FormGroup
                hasErrors={Boolean(props.error)}
                label={translateKey('serviceOrganizationSetting.holterAnalystOrganization')}
            >
                <OrganizationSelection
                    error={props.error}
                    hasActiveTcohAnalyst={true}
                    isClearable={true}
                    onChange={async (organizationId) => props.onChange(organizationId)}
                    onDoValidate={async () => {
                        if (props.onDoValidate) {
                            props.onDoValidate();
                        }
                    }}
                    placeholder={translateKey('organization.select')}
                    showCity={true}
                    value={props.ksyosHolterAnalystOrganizationId}
                />
            </FormGroup>
        </FormSection>
    );
}
